export default __webpack_public_path__ + "static/media/km2.e961ad55.png";